import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment.production';

/**
 * Prefers merchant portal JWT, then staff JWT from admin sign-in, then
 * `environment.apiAccessToken` for local builds.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  if (auth.redirectIfSessionJwtExpired()) {
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 401,
          statusText: 'Session expired',
          url: req.url,
        }),
    );
  }
  const merchantTok = auth.merchantAccessToken();
  const staffTok = auth.staffAccessToken();
  const token = merchantTok ?? staffTok ?? (environment.apiAccessToken?.trim() || '');
  if (!token) {
    return next(req);
  }
  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
